export default "__VITE_ASSET__BlK6AqKY__"